import React, {useState} from 'react';
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import {Link as RouterLink} from "react-router-dom";
import Container from "@mui/material/Container";
import * as yup from "yup";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import FormControl from "@mui/material/FormControl";
import {sendPasswordResetEmail} from "firebase/auth";
import {getFirebase} from "../../config/firebase.config";
import Alert from "@mui/material/Alert";

const schema = yup.object({
    email: yup.string().email("Invalid email address!").required("Email required!"),
}).required();

const {auth} = getFirebase();

const ForgotPassword = () => {
    const formValues = {email: ''};
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const {handleSubmit, control, formState: {errors}, reset} = useForm({
        defaultValues: formValues,
        resolver: yupResolver(schema)
    });
    const onSubmit = async ({email}) => {
        try {
            setLoading(true);
            setError(null);
            setSubmitted(true);
            await sendPasswordResetEmail(auth, email);
        } catch (error) {
            setError({message: `Error(${error.code})`});
        } finally {
            setLoading(false);
            reset(formValues);
        }
    };
    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Avatar sx={{m: 1, width: 100, height: 100}} src="/logo.png"/>

                <Typography component="h1" variant="h4">
                    Chautari Homecare LLC
                </Typography>
                <Typography variant="subtitle1" gutterBottom component="div">
                    Missed EVV Account recovery
                </Typography>
                {error && <Alert severity="error">{error.message}</Alert>}
                {!error && submitted && !loading &&
                    <React.Fragment>
                        <Typography variant="body1" gutterBottom sx={{mt: 1, color: 'info.dark'}}>
                            Success! You will receive an email shortly. Please contact us for any inconvenience.
                        </Typography>
                    </React.Fragment>
                }
                <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{mt: 1}}>
                    <FormControl fullWidth={true}>
                        <Controller
                            name="email"
                            control={control}
                            render={({field}) =>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    label="Employee Email Address"
                                    autoComplete="email"
                                    autoFocus
                                    error={!!errors.email}
                                    helperText={errors.email && errors.email?.message}
                                    {...field}
                                />
                            }
                        />
                    </FormControl>
                    <Button
                        type="submit"
                        fullWidth
                        disabled={loading}
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        Get password reset link
                    </Button>
                    <Grid container>
                        <Grid item>
                            <Link component={RouterLink} to={"/auth/login"} variant="body2">
                                Return to login
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
};

export default ForgotPassword;